import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { UserMetaDataResponse } from '../types';
import { apiRequest } from './utils/apiClient';

export const accountsApi = {
  getUserMetaData: async (
    username: string,
    callback: (res: UserMetaDataResponse) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${username}`;
    try {
      const data = await apiRequest<UserMetaDataResponse>({
        url,
        isAuth: true,
        method: 'GET',
      });
      callback(data);
    } catch (error) {
      logError('Error fetching user metadata', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },

  updateUserMetaData: async (
    username: string,
    rawData: Partial<UserMetaDataResponse> | { year_of_birth: string },
    successCallback: (res: UserMetaDataResponse) => void,
    errorCallback: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${username}`;
    try {
      const data = await apiRequest<UserMetaDataResponse>({
        url,
        isAuth: true,
        method: 'PATCH',
        data: rawData,
        contentType: 'application/merge-patch+json',
      });
      successCallback(data);
    } catch (error) {
      logError('Error updating user metadata', error);
      errorCallback(error as Error);
    }
  },

  updateUserImage: async (file: File, username: string): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${username}/image`;
    const formData = new FormData();
    formData.append('file', file);

    try {
      await apiRequest<void>({
        url,
        isAuth: true,
        method: 'POST',
        data: formData,
      });
    } catch (error) {
      logError('Error updating user image', error);
    }
  },
};
